var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/form-actions.tsx
import { cn } from "@repo/utils";
function FormActions({ onCancel, isSubmitting = false, submitLabel, mode = "create", showCancel = true, disabled = false }) {
  const label = submitLabel ?? (mode === "create" ? "Create" : "Update");
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-end items-center gap-3 pt-6 border-t border-border"
  }, showCancel && /* @__PURE__ */ React.createElement("button", {
    type: "button",
    onClick: onCancel ?? (() => window.history.back()),
    disabled: isSubmitting,
    className: "px-4 py-2 text-sm font-medium text-text-secondary bg-surface-2 border border-border rounded-[8px] hover:bg-surface-3 transition-colors disabled:opacity-50"
  }, "Cancel"), /* @__PURE__ */ React.createElement("button", {
    type: "submit",
    disabled: isSubmitting || disabled,
    className: cn("px-4 py-2 text-sm font-semibold text-white rounded-[8px] transition-colors disabled:opacity-50 inline-flex items-center gap-2", "bg-accent-500 hover:bg-accent-600")
  }, isSubmitting && /* @__PURE__ */ React.createElement("svg", {
    className: "animate-spin h-4 w-4",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /* @__PURE__ */ React.createElement("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /* @__PURE__ */ React.createElement("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
  })), label));
}
__name(FormActions, "FormActions");

// src/form-modal.tsx
import * as React2 from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn as cn2 } from "@repo/utils";
function FormModal({ open, onClose, title, description, modal, submitLabel = "Save", cancelLabel = "Cancel", className, children }) {
  return /* @__PURE__ */ React2.createElement(DialogPrimitive.Root, {
    open,
    onOpenChange: /* @__PURE__ */ __name((v) => {
      if (!v) onClose();
    }, "onOpenChange")
  }, /* @__PURE__ */ React2.createElement(DialogPrimitive.Portal, null, /* @__PURE__ */ React2.createElement(DialogPrimitive.Overlay, {
    className: "fixed inset-0 z-overlay bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
  }), /* @__PURE__ */ React2.createElement(DialogPrimitive.Content, {
    className: cn2("fixed left-1/2 top-1/2 z-modal grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border border-border bg-surface-1 p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-xl", className)
  }, title && /* @__PURE__ */ React2.createElement("div", {
    className: "flex flex-col space-y-1.5"
  }, /* @__PURE__ */ React2.createElement(DialogPrimitive.Title, {
    className: "text-lg font-semibold leading-none tracking-tight text-text-primary"
  }, title), description && /* @__PURE__ */ React2.createElement(DialogPrimitive.Description, {
    className: "text-sm text-text-muted"
  }, description)), /* @__PURE__ */ React2.createElement("form", {
    onSubmit: modal.handleSubmit,
    className: "contents"
  }, children, /* @__PURE__ */ React2.createElement("div", {
    className: "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2 pt-4"
  }, /* @__PURE__ */ React2.createElement("button", {
    type: "button",
    onClick: onClose,
    disabled: modal.isSubmitting,
    className: cn2("inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium", "border border-border bg-surface-1 text-text-primary", "hover:bg-surface-2 transition-colors", "disabled:opacity-50 disabled:cursor-not-allowed")
  }, cancelLabel), /* @__PURE__ */ React2.createElement("button", {
    type: "submit",
    disabled: modal.isSubmitting,
    className: cn2("inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium", "bg-accent-500 text-white", "hover:bg-accent-600 transition-colors", "disabled:opacity-50 disabled:cursor-not-allowed", modal.isSubmitting && "opacity-50 cursor-wait")
  }, modal.isSubmitting ? /* @__PURE__ */ React2.createElement("span", {
    className: "flex items-center gap-2"
  }, /* @__PURE__ */ React2.createElement("span", {
    className: "h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"
  }), "Submitting\u2026") : submitLabel))), /* @__PURE__ */ React2.createElement(DialogPrimitive.Close, {
    className: "absolute right-4 top-4 rounded-sm h-8 w-8 inline-flex items-center justify-center opacity-70 transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none"
  }, /* @__PURE__ */ React2.createElement("svg", {
    className: "h-4 w-4",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: "1.5",
    stroke: "currentColor"
  }, /* @__PURE__ */ React2.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  })), /* @__PURE__ */ React2.createElement("span", {
    className: "sr-only"
  }, "Close")))));
}
__name(FormModal, "FormModal");

// src/field-error.ts
function extractError(errors, submissionAttempts, isBlurred) {
  if (submissionAttempts === 0 && !isBlurred) return void 0;
  if (!errors || errors.length === 0) return void 0;
  const err = errors[0];
  if (!err) return void 0;
  if (typeof err === "string") return err;
  if (typeof err === "object") {
    if ("message" in err && typeof err.message === "string") return err.message;
    if ("error" in err && typeof err.error === "string") return err.error;
    try {
      return JSON.stringify(err);
    } catch (stringifyErr) {
      console.warn("fieldError: failed to stringify field validation error", stringifyErr);
      return "Validation error";
    }
  }
  return String(err);
}
__name(extractError, "extractError");
function fieldError(metaOrErrors, submissionAttempts) {
  if (!metaOrErrors) return void 0;
  if (Array.isArray(metaOrErrors)) {
    return extractError(metaOrErrors, submissionAttempts, false);
  }
  const meta = metaOrErrors;
  return extractError(meta.errors ?? [], submissionAttempts, meta.isBlurred ?? false);
}
__name(fieldError, "fieldError");

// src/dynamic-contact-list.tsx
import React3 from "react";
var DynamicContactList = /* @__PURE__ */ __name(({ contacts, onChange, disabled = false }) => {
  const handleAdd = /* @__PURE__ */ __name((type) => {
    const isFirst = contacts.length === 0;
    onChange([
      ...contacts,
      {
        type,
        label: type === "PHONE" ? "MOBILE" : "PERSONAL",
        value: "",
        isPrimary: isFirst,
        isWhatsapp: type === "PHONE"
      }
    ]);
  }, "handleAdd");
  const handleRemove = /* @__PURE__ */ __name((index) => {
    const updated = contacts.filter((_, i) => i !== index);
    if (contacts[index]?.isPrimary && updated.length > 0) {
      updated[0].isPrimary = true;
    }
    onChange(updated);
  }, "handleRemove");
  const handleChangeField = /* @__PURE__ */ __name((index, field, val) => {
    const updated = contacts.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [field]: val
        };
      }
      if (field === "isPrimary" && val === true) {
        return {
          ...item,
          isPrimary: false
        };
      }
      return item;
    });
    onChange(updated);
  }, "handleChangeField");
  return /* @__PURE__ */ React3.createElement("div", {
    className: "space-y-4"
  }, /* @__PURE__ */ React3.createElement("div", {
    className: "flex items-center justify-between"
  }, /* @__PURE__ */ React3.createElement("h4", {
    className: "text-sm font-semibold text-gray-900"
  }, "Contact Information (1-to-Many)"), /* @__PURE__ */ React3.createElement("div", {
    className: "flex space-x-2"
  }, /* @__PURE__ */ React3.createElement("button", {
    type: "button",
    disabled,
    onClick: /* @__PURE__ */ __name(() => handleAdd("PHONE"), "onClick"),
    className: "inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
  }, "+ Add Phone"), /* @__PURE__ */ React3.createElement("button", {
    type: "button",
    disabled,
    onClick: /* @__PURE__ */ __name(() => handleAdd("EMAIL"), "onClick"),
    className: "inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
  }, "+ Add Email"))), contacts.length === 0 ? /* @__PURE__ */ React3.createElement("p", {
    className: "text-xs text-gray-500 italic"
  }, "No contacts added yet. Click above to add multiple phone numbers or emails.") : /* @__PURE__ */ React3.createElement("div", {
    className: "space-y-3"
  }, contacts.map((contact, idx) => /* @__PURE__ */ React3.createElement("div", {
    key: contact.id || idx,
    className: "flex items-center space-x-3 p-3 bg-gray-50 rounded-md border border-gray-200"
  }, /* @__PURE__ */ React3.createElement("span", {
    className: "text-xs font-bold text-gray-500 uppercase w-16"
  }, contact.type), /* @__PURE__ */ React3.createElement("input", {
    type: "text",
    placeholder: "Label (e.g. Work, Home, WhatsApp)",
    value: contact.label,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "label", e.target.value), "onChange"),
    className: "w-32 text-xs border border-gray-300 rounded px-2 py-1"
  }), /* @__PURE__ */ React3.createElement("input", {
    type: contact.type === "EMAIL" ? "email" : "tel",
    placeholder: contact.type === "EMAIL" ? "name@example.com" : "+91 9999999999",
    value: contact.value,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "value", e.target.value), "onChange"),
    className: "flex-1 text-xs border border-gray-300 rounded px-2 py-1"
  }), /* @__PURE__ */ React3.createElement("label", {
    className: "inline-flex items-center text-xs text-gray-700 cursor-pointer"
  }, /* @__PURE__ */ React3.createElement("input", {
    type: "checkbox",
    checked: contact.isPrimary,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "isPrimary", e.target.checked), "onChange"),
    className: "mr-1 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
  }), "Primary"), contact.type === "PHONE" && /* @__PURE__ */ React3.createElement("label", {
    className: "inline-flex items-center text-xs text-gray-700 cursor-pointer"
  }, /* @__PURE__ */ React3.createElement("input", {
    type: "checkbox",
    checked: !!contact.isWhatsapp,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "isWhatsapp", e.target.checked), "onChange"),
    className: "mr-1 rounded border-gray-300 text-green-600 focus:ring-green-500"
  }), "WhatsApp"), /* @__PURE__ */ React3.createElement("button", {
    type: "button",
    disabled,
    onClick: /* @__PURE__ */ __name(() => handleRemove(idx), "onClick"),
    className: "text-xs text-red-600 hover:text-red-800 font-medium"
  }, "Remove")))));
}, "DynamicContactList");

// src/dynamic-address-list.tsx
import React4 from "react";
var DynamicAddressList = /* @__PURE__ */ __name(({ addresses, onChange, disabled = false }) => {
  const handleAdd = /* @__PURE__ */ __name(() => {
    const isFirst = addresses.length === 0;
    onChange([
      ...addresses,
      {
        addressType: "RESIDENTIAL",
        label: "PRIMARY",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateCode: "TN",
        pincode: "",
        isPrimary: isFirst
      }
    ]);
  }, "handleAdd");
  const handleRemove = /* @__PURE__ */ __name((index) => {
    const updated = addresses.filter((_, i) => i !== index);
    if (addresses[index]?.isPrimary && updated.length > 0) {
      updated[0].isPrimary = true;
    }
    onChange(updated);
  }, "handleRemove");
  const handleChangeField = /* @__PURE__ */ __name((index, field, val) => {
    const updated = addresses.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [field]: val
        };
      }
      if (field === "isPrimary" && val === true) {
        return {
          ...item,
          isPrimary: false
        };
      }
      return item;
    });
    onChange(updated);
  }, "handleChangeField");
  return /* @__PURE__ */ React4.createElement("div", {
    className: "space-y-4"
  }, /* @__PURE__ */ React4.createElement("div", {
    className: "flex items-center justify-between"
  }, /* @__PURE__ */ React4.createElement("h4", {
    className: "text-sm font-semibold text-gray-900"
  }, "Address Details (1-to-Many)"), /* @__PURE__ */ React4.createElement("button", {
    type: "button",
    disabled,
    onClick: handleAdd,
    className: "inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
  }, "+ Add Address")), addresses.length === 0 ? /* @__PURE__ */ React4.createElement("p", {
    className: "text-xs text-gray-500 italic"
  }, "No addresses added yet. Click above to add multiple addresses.") : /* @__PURE__ */ React4.createElement("div", {
    className: "space-y-4"
  }, addresses.map((address, idx) => /* @__PURE__ */ React4.createElement("div", {
    key: address.id || idx,
    className: "p-4 bg-gray-50 rounded-md border border-gray-200 space-y-3"
  }, /* @__PURE__ */ React4.createElement("div", {
    className: "flex items-center justify-between"
  }, /* @__PURE__ */ React4.createElement("div", {
    className: "flex items-center space-x-2"
  }, /* @__PURE__ */ React4.createElement("select", {
    value: address.addressType,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "addressType", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1 bg-white"
  }, /* @__PURE__ */ React4.createElement("option", {
    value: "RESIDENTIAL"
  }, "Residential"), /* @__PURE__ */ React4.createElement("option", {
    value: "OFFICE"
  }, "Office"), /* @__PURE__ */ React4.createElement("option", {
    value: "PERMANENT"
  }, "Permanent"), /* @__PURE__ */ React4.createElement("option", {
    value: "COMMUNICATION"
  }, "Communication"), /* @__PURE__ */ React4.createElement("option", {
    value: "BILLING"
  }, "Billing"), /* @__PURE__ */ React4.createElement("option", {
    value: "SHIPPING"
  }, "Shipping"), /* @__PURE__ */ React4.createElement("option", {
    value: "SITE"
  }, "Site"), /* @__PURE__ */ React4.createElement("option", {
    value: "OTHER"
  }, "Other")), /* @__PURE__ */ React4.createElement("input", {
    type: "text",
    placeholder: "Label (e.g. Primary, Work HQ)",
    value: address.label,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "label", e.target.value), "onChange"),
    className: "w-36 text-xs border border-gray-300 rounded px-2 py-1"
  })), /* @__PURE__ */ React4.createElement("div", {
    className: "flex items-center space-x-3"
  }, /* @__PURE__ */ React4.createElement("label", {
    className: "inline-flex items-center text-xs text-gray-700 cursor-pointer"
  }, /* @__PURE__ */ React4.createElement("input", {
    type: "checkbox",
    checked: address.isPrimary,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "isPrimary", e.target.checked), "onChange"),
    className: "mr-1 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
  }), "Primary Address"), /* @__PURE__ */ React4.createElement("button", {
    type: "button",
    disabled,
    onClick: /* @__PURE__ */ __name(() => handleRemove(idx), "onClick"),
    className: "text-xs text-red-600 hover:text-red-800 font-medium"
  }, "Remove"))), /* @__PURE__ */ React4.createElement("div", {
    className: "grid grid-cols-2 gap-3"
  }, /* @__PURE__ */ React4.createElement("input", {
    type: "text",
    placeholder: "Address Line 1 *",
    value: address.addressLine1,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "addressLine1", e.target.value), "onChange"),
    className: "col-span-2 text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React4.createElement("input", {
    type: "text",
    placeholder: "Address Line 2",
    value: address.addressLine2 || "",
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "addressLine2", e.target.value), "onChange"),
    className: "col-span-2 text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React4.createElement("input", {
    type: "text",
    placeholder: "City *",
    value: address.city,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "city", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React4.createElement("input", {
    type: "text",
    placeholder: "State Code (e.g. TN) *",
    value: address.stateCode,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "stateCode", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React4.createElement("input", {
    type: "text",
    placeholder: "Pincode *",
    value: address.pincode,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "pincode", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }))))));
}, "DynamicAddressList");

// src/dynamic-bank-list.tsx
import React5 from "react";
var DynamicBankList = /* @__PURE__ */ __name(({ banks, onChange, disabled = false }) => {
  const handleAdd = /* @__PURE__ */ __name(() => {
    const isFirst = banks.length === 0;
    onChange([
      ...banks,
      {
        bankName: "",
        branchName: "",
        accountType: "SAVINGS",
        accountNumber: "",
        ifscCode: "",
        vpaHandle: "",
        isPrimary: isFirst
      }
    ]);
  }, "handleAdd");
  const handleRemove = /* @__PURE__ */ __name((index) => {
    const updated = banks.filter((_, i) => i !== index);
    if (banks[index]?.isPrimary && updated.length > 0) {
      updated[0].isPrimary = true;
    }
    onChange(updated);
  }, "handleRemove");
  const handleChangeField = /* @__PURE__ */ __name((index, field, val) => {
    const updated = banks.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          [field]: val
        };
      }
      if (field === "isPrimary" && val === true) {
        return {
          ...item,
          isPrimary: false
        };
      }
      return item;
    });
    onChange(updated);
  }, "handleChangeField");
  return /* @__PURE__ */ React5.createElement("div", {
    className: "space-y-4"
  }, /* @__PURE__ */ React5.createElement("div", {
    className: "flex items-center justify-between"
  }, /* @__PURE__ */ React5.createElement("h4", {
    className: "text-sm font-semibold text-gray-900"
  }, "Bank Accounts & VPAs (1-to-Many)"), /* @__PURE__ */ React5.createElement("button", {
    type: "button",
    disabled,
    onClick: handleAdd,
    className: "inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
  }, "+ Add Bank Account")), banks.length === 0 ? /* @__PURE__ */ React5.createElement("p", {
    className: "text-xs text-gray-500 italic"
  }, "No bank accounts added yet. Click above to add multiple bank accounts or VPAs.") : /* @__PURE__ */ React5.createElement("div", {
    className: "space-y-4"
  }, banks.map((bank, idx) => /* @__PURE__ */ React5.createElement("div", {
    key: bank.id || idx,
    className: "p-4 bg-gray-50 rounded-md border border-gray-200 space-y-3"
  }, /* @__PURE__ */ React5.createElement("div", {
    className: "flex items-center justify-between"
  }, /* @__PURE__ */ React5.createElement("select", {
    value: bank.accountType,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "accountType", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1 bg-white"
  }, /* @__PURE__ */ React5.createElement("option", {
    value: "SAVINGS"
  }, "Savings Account"), /* @__PURE__ */ React5.createElement("option", {
    value: "CURRENT"
  }, "Current Account"), /* @__PURE__ */ React5.createElement("option", {
    value: "OVERDRAFT"
  }, "Overdraft Account"), /* @__PURE__ */ React5.createElement("option", {
    value: "NRE_NRO"
  }, "NRE / NRO Account")), /* @__PURE__ */ React5.createElement("div", {
    className: "flex items-center space-x-3"
  }, /* @__PURE__ */ React5.createElement("label", {
    className: "inline-flex items-center text-xs text-gray-700 cursor-pointer"
  }, /* @__PURE__ */ React5.createElement("input", {
    type: "checkbox",
    checked: bank.isPrimary,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "isPrimary", e.target.checked), "onChange"),
    className: "mr-1 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
  }), "Primary Payout Account"), /* @__PURE__ */ React5.createElement("button", {
    type: "button",
    disabled,
    onClick: /* @__PURE__ */ __name(() => handleRemove(idx), "onClick"),
    className: "text-xs text-red-600 hover:text-red-800 font-medium"
  }, "Remove"))), /* @__PURE__ */ React5.createElement("div", {
    className: "grid grid-cols-2 gap-3"
  }, /* @__PURE__ */ React5.createElement("input", {
    type: "text",
    placeholder: "Bank Name *",
    value: bank.bankName,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "bankName", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React5.createElement("input", {
    type: "text",
    placeholder: "Branch Name",
    value: bank.branchName || "",
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "branchName", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React5.createElement("input", {
    type: "text",
    placeholder: "Account Number *",
    value: bank.accountNumber,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "accountNumber", e.target.value), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React5.createElement("input", {
    type: "text",
    placeholder: "IFSC Code *",
    value: bank.ifscCode,
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "ifscCode", e.target.value.toUpperCase()), "onChange"),
    className: "text-xs border border-gray-300 rounded px-2 py-1.5"
  }), /* @__PURE__ */ React5.createElement("input", {
    type: "text",
    placeholder: "UPI VPA (e.g. name@upi)",
    value: bank.vpaHandle || "",
    disabled,
    onChange: /* @__PURE__ */ __name((e) => handleChangeField(idx, "vpaHandle", e.target.value), "onChange"),
    className: "col-span-2 text-xs border border-gray-300 rounded px-2 py-1.5"
  }))))));
}, "DynamicBankList");
export {
  DynamicAddressList,
  DynamicBankList,
  DynamicContactList,
  FormActions,
  FormModal,
  fieldError
};
//# sourceMappingURL=index.js.map